import * as token from "@universityofmaryland/web-token-library";
import { debounce } from "@universityofmaryland/web-utilities-library/performance";
import { createCompositeMediaCaption } from "../elements/caption.js";
import { layoutImage } from "../../../layout/image.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
const ELEMENT_MEDIA_INLINE_CONTAINER = "element-media-with-caption-container";
const ELEMENT_OBJECT_CAPTION_CONTAINER = "element-media-caption-container";
const ObjectContainer = `
  .${ELEMENT_OBJECT_CAPTION_CONTAINER} {
    display: flex;
    flex-direction: column;
    padding-bottom: ${token.spacing.sm};
    max-width: 100%;
  }
`;
const STYLES_MEDIA_INLINE_ELEMENT = `
  .${ELEMENT_MEDIA_INLINE_CONTAINER} {
    display: inline-block;
    max-width: 100%;
  }

  ${layoutImage.Styles}
  ${createCompositeMediaCaption.Styles}
  ${ObjectContainer}
`;
const CreateMediaWithCaption = (props) => (() => {
  const { caption, image, isThemeDark } = props;
  const hasCaption = caption && caption !== null;
  const elementContainer = document.createElement("div");
  const objectContainer = document.createElement("div");
  const sizeCaption = () => {
    const imageContainer = elementContainer.querySelector(
      `.${layoutImage.Elements.container}`
    );
    const caption2 = elementContainer.querySelector(
      `.${createCompositeMediaCaption.Elements.container}`
    );
    if (caption2) {
      caption2.style.width = `${imageContainer.offsetWidth}px`;
      caption2.style.display = `block`;
    }
  };
  const eventResize = () => {
    sizeCaption();
  };
  if (image) {
    objectContainer.appendChild(
      layoutImage.CreateElement({
        image,
        showCaption: true
      })
    );
  }
  const load = () => {
    const checkSizing = () => {
      const caption2 = objectContainer.querySelector(
        `.${createCompositeMediaCaption.Elements.container}`
      );
      if (caption2) {
        caption2.style.opacity = `1`;
      }
    };
    image?.addEventListener("load", () => {
      checkSizing();
      setTimeout(() => {
        checkSizing();
      }, 500);
    });
  };
  if (hasCaption) {
    const captionElement = createCompositeMediaCaption.CreateElement({
      caption,
      isThemeDark
    });
    captionElement.style.display = `none`;
    objectContainer.appendChild(captionElement);
  }
  if (objectContainer.children.length > 0) {
    elementContainer.appendChild(objectContainer);
  }
  objectContainer.classList.add(ELEMENT_OBJECT_CAPTION_CONTAINER);
  elementContainer.classList.add(ELEMENT_MEDIA_INLINE_CONTAINER);
  window.addEventListener(
    "resize",
    debounce(() => {
      eventResize();
    }, 20)
  );
  setTimeout(() => {
    eventResize();
  }, 100);
  return {
    element: elementContainer,
    events: {
      load
    },
    styles: STYLES_MEDIA_INLINE_ELEMENT
  };
})();
const createCompositeMediaInlineCaption = CreateMediaWithCaption;
export {
  createCompositeMediaInlineCaption
};
//# sourceMappingURL=caption.js.map
